module.exports = __webpack_public_path__ + "img/bhrt.d252ed79.png";